import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          src="https://public.readdy.ai/ai/video_res/019fb1ff-ef16-77b3-ae4a-089103736c59.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/40 to-primary-950/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-500/15 backdrop-blur-sm border border-accent-500/20 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-base font-label text-accent-300 tracking-wider">崧博出版合作經銷品牌</span>
          </div>

          <h1 className="font-heading text-xl md:text-2xl font-bold text-white/90 mb-3 text-shadow-hero-sub">
            山頂視角 PeakView
          </h1>

          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 text-shadow-hero">
            從不同內容出發，找到值得閱讀的視角
          </h2>

          <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-2xl mx-auto mb-6 text-shadow-hero-sub">
            山頂視角 PeakView 為崧博出版合作經銷品牌，提供品牌介紹、出版書籍與合作購書通路。
          </p>

          <p className="font-heading text-lg md:text-xl italic text-accent-300 mb-8 font-medium text-shadow-hero-sub">
            不只看事件，也看見事件背後的結構。
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/about"
              className="px-6 py-3 bg-accent-500 text-primary-950 font-label font-semibold text-base rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap"
            >
              認識山頂視角
            </Link>
            <Link
              to="/stores"
              className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white font-label font-medium text-base rounded-full hover:bg-white/25 border border-white/20 transition-all duration-300 whitespace-nowrap"
            >
              查看合作購書通路
            </Link>
            <Link
              to="/faq"
              className="px-6 py-3 bg-accent-500/20 text-white font-label font-medium text-base rounded-full hover:bg-accent-500/30 border border-accent-500/30 transition-all duration-300 whitespace-nowrap flex items-center gap-1"
            >
              常見問答
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-accent-50/50 to-transparent"></div>
    </section>
  );
}